import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';
import { captureException } from '@sentry/react';
import { Typography } from '@mui/material';

import NotFoundPanel from '../NotFoundPanel';

export default function ErrorElement() {
  const { t } = useTranslation();
  const error = useRouteError();

  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <NotFoundPanel
      title={t('error-boundary.title')}
      content={<Typography>{t('error-boundary.description')}</Typography>}
    />
  );
}
